import { Component } from '@angular/core';
import { DurationDialogModel } from '../../models/station-dialog.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { provideNativeDateAdapter } from '@angular/material/core';
import { TaskModel } from '../../models/station.model';
import { QBuiltService } from 'src/app/modules/qbuilt/services/qbuilt-service';

@Component({
  selector: 'duration-dialog',
  imports: [
    MatDialogModule,
    MatFormFieldModule,
    MatDatepickerModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './duration-dialog.component.html',
  styleUrl: './duration-dialog.component.scss',
})
export class DurationDialogComponent {
  today = new Date();

  dateForm = new FormGroup({
    startDate: new FormControl<Date | null>(null),
    endDate: new FormControl<Date | null>(null),
  });

  dataCaptureComplete: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DurationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: DurationDialogModel,
    private qbuiltService: QBuiltService,
  ) {
    dialogRef.disableClose = true;
  }

  ngOnInit() {
    if (this.dialogData.task.durationStart !== undefined) {
      this.dateForm.setValue({
        startDate: this.dialogData.task.durationStart,
        endDate: this.dialogData.task.durationEnd,
      });
    }
  }

  setTaskDuration(task: TaskModel, startDate: Date, endDate: Date) {
    //find task by unique id in station list and set duration
    this.dialogData.stationList.forEach(
      (station: { taskList: TaskModel[] }) => {
        station.taskList.forEach((statTask: TaskModel) => {
          if (statTask.id === task.id) {
            statTask.durationStart = startDate;
            statTask.durationEnd = endDate;
          }
        });
      },
    );

    //send updated station data back to
    this.dialogRef.close(this.dialogData.stationList);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
